var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileUnchecked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7215 21.9519C12.7215 31.1519 -7.27854 18.5519 3.82147 3.9519C12.7215 -5.2481 32.7215 7.4519 21.7215 21.9519Z",
    fill: "#223661"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M12.7214 17.8519C12.8214 17.8519 12.9213 17.8519 12.9213 17.7519C13.0213 17.7519 13.1214 17.7519 13.1214 17.6519C13.2214 17.6519 13.3213 17.5519 13.3213 17.4519C13.4213 17.3519 13.4214 17.2519 13.5214 17.1519V13.4519H17.1214C17.5214 13.3519 17.6214 13.0519 17.6214 12.7519C17.6214 12.6519 17.6214 12.5519 17.5214 12.5519C17.5214 12.4519 17.5213 12.3519 17.4213 12.3519C17.4213 12.2519 17.3214 12.2519 17.2214 12.1519C17.1214 12.0519 17.0213 12.0519 16.9213 11.9519H13.2214V8.75194C13.2214 8.35194 13.1213 8.15193 12.8213 8.05192H12.5214C12.2214 7.95193 12.1213 8.05189 11.9213 8.1519H11.8213C11.7213 8.2519 11.6214 8.4519 11.6214 8.6519V12.0519H8.22136C7.82137 12.0519 7.62142 12.1519 7.52141 12.4519V12.7519C7.4214 12.9519 7.52138 13.1519 7.62139 13.3519V13.4519H7.72136C7.82137 13.5519 8.02135 13.6519 8.22136 13.6519H11.7214V17.3519C12.1214 17.7519 12.4213 17.9519 12.7214 17.8519Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileUnchecked);
export default __webpack_public_path__ + "static/media/profile-unchecked.29bb7767a511bd07ccf17f806c45cda3.svg";
export { ForwardRef as ReactComponent };